export const unitPriceDropdown = () => [
    { id: 'Monthly', description: 'Monthly' },
    { id: 'Annually', description: 'Annually' }
  ];